'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapPropsAndThemeToStyle = exports.defaultStyle = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectResolvePath = require('object-resolve-path');

var _objectResolvePath2 = _interopRequireDefault(_objectResolvePath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStyle = exports.defaultStyle = {
  display: 'block',
  fontFamily: 'HelveticaMedCn',
  width: '100%',
  height: '40px',
  textAlign: 'center',
  '&:focus': {
    outline: '0'
  },

  '& .anchor': {
    display: 'flex',
    height: '100%',
    justifyContent: 'center'
  },

  '& .inner': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    // Stupid offset for Nike font baseline issue...
    position: 'relative',
    top: '2px'
  }
};

var mapPropsAndThemeToStyle = exports.mapPropsAndThemeToStyle = function mapPropsAndThemeToStyle(_ref, theme) {
  var disabled = _ref.disabled;
  return (0, _extends3.default)({
    cursor: disabled ? 'not-allowed' : 'pointer',
    margin: theme.marginBase * 10 + 'px ' + theme.marginBase * 10 + 'px ' + theme.marginBase * 10 + 'px 0px',
    fontSize: theme.fontBase * 14 + 'px'
  }, (0, _objectResolvePath2.default)(theme, 'Button.css') || {});
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/buttons/Button/Button.style.js
// module id = 342
// module chunks = 0